import ninegrid from "../index.js";

class nxSpan extends HTMLElement
{
	#enableHtml;
	#target;
	#key;
	#value;
	#datalist;
	#dataSource = [];
	
	constructor () {
		super();
		
		this.#enableHtml = this.getAttribute("enable-html") == "true";
		
		$(() => { this.#initialize(); });
	};
	
	connectedCallback() {
		if (ninegrid.getLocale() == "ko") {
			console.warn("nx-span 컴포넌트는 더 이상 사용되지 않을 예정입니다. nx-i18n 컴포넌트로 대체하세요.");
		}
		else {
			console.warn("The nx-span component will be deprecated. Replace with nx-i18n component.");
		}
	};
	
	refresh = () => {
		if (this.#dataSource.length < 0 || ninegrid.isNull(this.#value)) return;
			
		var index = this.#dataSource.findIndex(m => m[this.#key] == ninegrid.global.locale);
		if (index < 0) index = 0;
		

		
		this.#target.innerHTML = this.#dataSource[index][this.#value];

		$("datalist", this).remove();
		$(this).append(this.#datalist);
	};
	
	#initialize = () => {

		this.#datalist = "<datalist>";
		this.querySelectorAll("datalist option").forEach((option,i) => {
			var o = {};
			for (var j = 0; j < option.attributes.length; j++) {
				//o[option.attributes[j].name] = option.attributes[j].value.replaceAll("<", "&lt;").replaceAll(">", "&gt;");//.replaceAll('&#34;',' ');
				o[option.attributes[j].name] = this.#enableHtml ? option.attributes[j].value : option.attributes[j].value.replaceAll("<", "&lt;").replaceAll(">", "&gt;");//.replaceAll('&#34;',' ');
				
				if (i == 0) {
					["locale","lang","key","code"].includes(option.attributes[j].name) ? this.#key = option.attributes[j].name : this.#value = option.attributes[j].name;
				}
			}
			
			this.#datalist += "<option";
			for (const prop in o) {
				this.#datalist += ` ${prop}="${o[prop]}"`;
			}
			this.#datalist += "></option>";

			this.#dataSource.push(o);
		});
		this.#datalist += "</datalist>";
		

		const s = this.innerHTML;
		
		this.innerHTML = `
			<span>${s}</span>
		`;
		
		this.#target = this.querySelector("span");
		
		for (var i = 0; i < this.attributes.length; i++) {
			this.#target.setAttribute(this.attributes[i].name, this.attributes[i].value);
		}
		
		this.refresh();
	};
}

if (!customElements.get('nx-span')) {
	customElements.define("nx-span", nxSpan);
}



